<script setup lang="ts">
import { TabsContent, TabsList, TabsRoot, TabsTrigger } from 'radix-vue'

const SUGGESTIONS_AMOUNT = 20
const MIN_SUGGESTIONS_AMOUNT = 4
const tabTitles = {
  relatedProducts: 'weThinkYouLike',
  similarProducts: 'similarProducts',
}

const productStore = useProductStore()

const relatedProducts = computed(() =>
  productStore.recommendations.map(sku => productStore.products[sku]!).slice(0, SUGGESTIONS_AMOUNT),
)

const similarProducts = computed(() =>
  productStore.similar.map(sku => productStore.products[sku]!).slice(0, SUGGESTIONS_AMOUNT),
)

const tabs = computed(() => [
  { key: 'relatedProducts', title: tabTitles.relatedProducts, content: relatedProducts.value },
  { key: 'similarProducts', title: tabTitles.similarProducts, content: similarProducts.value },
])

const tabsWithContent = computed(() => tabs.value.filter(tab => tab.content.length > 0 && tab.content.length >= MIN_SUGGESTIONS_AMOUNT))

const activeTabKey = ref(tabsWithContent.value[0]?.key)
</script>

<template>
  <TabsRoot
    v-model="activeTabKey"
    class="suggestions"
  >
    <TabsList
      class="tabs-list"
      :aria-label="$t('relatedProductsSection')"
    >
      <TabsTrigger
        v-for="tab in tabsWithContent"
        :key="tab.key"
        class="tabs-trigger"
        :value="tab.key"
      >
        {{ $t(tab.title) }}
      </TabsTrigger>
    </TabsList>
    <TabsContent
      v-for="tab in tabsWithContent"
      :key="tab.key"
      class="TabsContent"
      :value="tab.key"
    >
      <LazyProductSuggestionCarousel :products="tab.content" />
    </TabsContent>
  </TabsRoot>
</template>

<style lang="scss" scoped>
.suggestions {
  padding: 1.6rem 2rem;
  max-width: 100%;
  overflow-x: hidden;
}

.tabs-trigger[data-active="true"] {
  line-height: 2.5rem;
  display: inline-block;
  background-image: url('/icons/wavyLineBlue.svg');
  position: relative;
  background-repeat: repeat-x;
  background-position-y: bottom;
}

.tabs-list {
  display: flex;
  gap: 2rem;
  margin-bottom: 0.5rem;
}
</style>
